import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Field, change } from 'redux-form';
import { FieldForm } from '@app/src/common/FieldForm';
import { renderSearchJob } from '@app/src/common/SearchJob';
import {
  fetchBrandVehicle,
  setBrandVehicleSelected,
  clearBrandVehicleData,
  clearBrandVehicleSelected,
  fetchBrandVehicleTop,
  clearModelVehicleData,
  clearModelVehicleSelected
} from '@app/src/views/StepOne/form';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';
import * as validate from '@app/src/utils/validations';
import { isGetAllBrand } from '@app/src/config/stepOne';
import { IconInfo, ModalContent } from './styled';
import { Modal } from '@app/src/common/Modal';
import { Icon } from '@app/src/common/Icon';
import { CATEGORIES } from '@app/src/config/categories';

const isClient = isClientEnv();
const BREAKPOINT = 768;
const MIN_CHAR_SEARCH = 2;

interface Props {
  typeVehicle?: number;
}

export const BrandVehicle: React.FC<Props> = ({ typeVehicle }) => {
  const dispatch = useDispatch();
  const brands = useSelector(state => state.brandVehicle.data);
  const brandsTop = useSelector(state => state.brandVehicleTop.data);
  const message = useSelector(state => state.brandVehicle.message);
  const isLoading = useSelector(state => state.brandVehicle.isFetching);
  const isLoadingTop = useSelector(state => state.brandVehicleTop.isFetching);
  const print = useSelector(state => state.print.general);
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryTheme = CATEGORIES[getAliasCategory()];
  const printBrandName = useSelector(state => state.print.general.brandVehicleName);
  const brandSelected = useSelector(state => state.brandVehicle.selected);
  const [isShowInfo, setIsShowInfo] = useState(false);

  useEffect(() => {
    if (isClient && window.innerWidth < BREAKPOINT && typeVehicle) {
      if (isGetAllBrand(typeVehicle)) {
        dispatch(fetchBrandVehicleTop(typeVehicle, 'all'));
      } else {
        dispatch(fetchBrandVehicleTop(typeVehicle));
      }
    }
    if (print.typeVehicle !== typeVehicle) {
      dispatch(clearBrandVehicleSelected());
      dispatch(change('stepOne', 'brandVehicle', null));
      dispatch(change('stepOne', 'brandVehicleName', ''));
      dispatch(change('stepOne', 'brandAdecsys', null));
    }
  }, [typeVehicle]);

  useEffect(() => {
    if (printBrandName) {
      dispatch(change('stepOne', 'brandVehicleName', print.brandVehicleName));
      dispatch(change('stepOne', 'brandVehicle', print.brandVehicle));
      dispatch(change('stepOne', 'brandAdecsys', print.brandAdecsys));
      dispatch(setBrandVehicleSelected(printBrandName));
    }
  }, [printBrandName]);

  const handleChangeSearch = (data) => {
    if (data) {
      const { name, id, adecsysId } = data;
      dispatch(change('stepOne', 'brandVehicle', id));
      dispatch(change('stepOne', 'brandVehicleName', name));
      dispatch(change('stepOne', 'brandAdecsys', adecsysId));
      dispatch(setBrandVehicleSelected(name));
    }
  };

  const handleChangeInput: Function = useCallback((value: string) => {
    if (isGetAllBrand(typeVehicle)) {
      dispatch(fetchBrandVehicle(typeVehicle, value, 'all'));
    } else {
      dispatch(fetchBrandVehicle(typeVehicle, value));
    }
  }, [typeVehicle]);

  const handleClickClose = () => {
    dispatch(clearBrandVehicleData());
    dispatch(clearBrandVehicleSelected());
    dispatch(change('stepOne', 'brandVehicle', null));
    dispatch(change('stepOne', 'brandVehicleName', ''));
    dispatch(change('stepOne', 'brandAdecsys', null));
    dispatch(clearModelVehicleData());
    dispatch(clearModelVehicleSelected());
    dispatch(change('stepOne', 'modelVehicle', null));
    dispatch(change('stepOne', 'modelAdecsys', null));
    dispatch(change('stepOne', 'modelVehicleName', ''));
  };

  const handleClickOpenModal = useCallback(() => {
    if (brandsTop && brandsTop.length === 0) {
      if (isGetAllBrand(typeVehicle)) {
        dispatch(fetchBrandVehicleTop(typeVehicle, 'all'));
      } else {
        dispatch(fetchBrandVehicleTop(typeVehicle));
      }
    }
  }, [typeVehicle, brandsTop]);

  const handleBlurSearch = () => {
    if (!brandSelected) {
      dispatch(change('stepOne', 'brandVehicle', null));
      dispatch(change('stepOne', 'brandVehicleName', ''));
      dispatch(change('stepOne', 'brandAdecsys', null));
    }
  };

  const handleCloseModal = useCallback(() => {
    setIsShowInfo(false);
   }, [dispatch]);

   const handleClickInfo = useCallback(() => {
     setIsShowInfo(true);
   }, [dispatch]);

  return(
  <FieldForm label="Marca"
    componentRight={
      <IconInfo onClick={handleClickInfo}>
        <Icon data-name="icon-info" fill={categoryTheme.color} width="12" height="16" />
      </IconInfo>
    }
  >
    <Field
      name="brandVehicleName"
      component={renderSearchJob}
      dataList={(brands && brands.length === 0) ? brandsTop : brands}
      handleChange={handleChangeSearch}
      handleClickClose={handleClickClose}
      handleChangeInput={handleChangeInput}
      handleClickOpenModal={handleClickOpenModal}
      handleBlur={handleBlurSearch}
      isLoading={isLoading || isLoadingTop}
      placeholder="Ej. Toyota"
      activeColor={COLORS.AMBAR}
      message={message}
      defaultJob={brandSelected}
      validate={[validate.required]}
      isLoadingModal={isLoadingTop}
      minCharForSearch={MIN_CHAR_SEARCH}
    />
    <Modal show={isShowInfo} closeModal={handleCloseModal}>
      <ModalContent>
        Si no encuentras la marca de tu vehículo, escríbenos.
      </ModalContent>
    </Modal>
  </FieldForm>
)};
